module.exports = __webpack_public_path__ + "img/communication.95bb2857.svg";